// extracted by mini-css-extract-plugin
export default {"modal":"Announcement_modal__G0tst","lottie":"Announcement_lottie__ktvGb","title":"Announcement_title__dfzCo","body":"Announcement_body__hRvHW","button":"Announcement_button__CobEC"};